import React from 'react';
import { withRouter } from 'react-router';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import EvansHalshawIcon from '@motorway/motorway-storybook-cra/dist/assets/icons/evans-halshaw-grey-mw-sb-cra.svg';
import InchcapeIcon from '@motorway/motorway-storybook-cra/dist/assets/icons/inchcape-grey-mw-sb-cra.svg';
import JardineIcon from '@motorway/motorway-storybook-cra/dist/assets/icons/jardine-grey-mw-sb-cra.svg';
import SytnerIcon from '@motorway/motorway-storybook-cra/dist/assets/icons/sytner-grey-mw-sb-cra.svg';
import ThurlowNunnIcon from '@motorway/motorway-storybook-cra/dist/assets/icons/thurlow-nunn-grey-mw-sb-cra.svg';

import { vehicleType } from 'Utilities/helpers';

import { Content } from 'LegacySBCRA/Content/Content';

import { usePageRefEvents } from '../../common/Hooks/usePageRefEvents';
import useBrandName from '../hooks/useBrandName';

import LocalTexts from './DealerLogos.json';

import styles from './DealerLogos.scss';

const LocalT = new MDText(LocalTexts);

const dealerLogos = [
  {
    alt: 'Sytner Icon', height: 64, id: 1, src: SytnerIcon, width: 201,
  },
  {
    alt: 'EvansHalshaw Icon', height: 64, id: 2, src: EvansHalshawIcon, width: 202,
  },
  {
    alt: 'Jardine Icon', height: 41, id: 3, src: JardineIcon, width: 139,
  },
  {
    alt: 'ThurlowNunn Icon', height: 56, id: 4, src: ThurlowNunnIcon, width: 176,
  },
  {
    alt: 'Inchcape Icon', height: 64, id: 5, src: InchcapeIcon, width: 202,
  },
];

const DealerLogos = ({ className, location, onLoad = () => {} }) => {
  const brandName = useBrandName();

  const { setRef } = usePageRefEvents({ onRefTrigger: onLoad });

  return (
    <Content className={styles.component} element="section" wrapper={{ className: cx(styles.componentWrapper, className) }}>
      <h3>
        {LocalT.translate('title', { vehicle: brandName || vehicleType(location.pathname) })}
      </h3>
      <div
        ref={(ref) => setRef(ref)}
        className={ styles.logos }
        data-testid='dealerLogos'
      >
        {dealerLogos.map(({
          alt, height, id, src, width,
        }) => (
          <div key={id} className={cx(styles.logo, styles[`logo${id + 1}`])}>
            <img alt={alt} height={height} loading="lazy" src={src} width={width} />
          </div>
        ))}
      </div>
    </Content>
  );
};

DealerLogos.propTypes = {
  className: PropTypes.string,
  location: ReactRouterPropTypes.location.isRequired,
  onLoad: PropTypes.func,
};

export default withRouter(DealerLogos);
